export default __webpack_public_path__ + "static/media/illust_pc_Eng.ea7ebef6.png";